import { LoadingButton } from '@mui/lab';
import React, { useContext, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    TextField,
} from '@mui/material';
import { useMutation } from '@apollo/client';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import { SnackbarContext } from '../../Providers/SnackbarProvider';
import { useNavigate } from 'react-router-dom';
import { graphql } from 'gql';
import { namedOperations } from 'gql/graphql';

const CreateShow = graphql(`
    mutation CreateShow_AddShowDialog($input: [ShowCreateInput!]!) {
        createShows(input: $input) {
            shows {
                id
                title
            }
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
}

export default function AddShowDialog({ open, onClose }: Props) {
    const navigate = useNavigate();

    const { setSelectedShow, setSelectedSeason } = useContext(SeasonShowContext);
    const { success, error } = useContext(SnackbarContext);

    const [title, setTitle] = useState<string>();

    const [createShow, { loading }] = useMutation(CreateShow);

    const handleSave = async () => {
        try {
            if (!title) {
                error('Title is required');
                return;
            }

            const result = await createShow({
                variables: {
                    input: [{ title }],
                },
                refetchQueries: [namedOperations.Query.GetShows_SeasonShowProvider],
            });
            const show = result.data?.createShows?.shows[0];

            if (!show) {
                error('Failed to create show');
                return;
            }

            setSelectedShow(show);
            setSelectedSeason(null);
            navigate('/');

            success('Show created');
            handleClose();
        } catch (e) {
            // @ts-ignore
            error('Failed to create show. ' + e.message);
        }
    }

    const handleClose = () => {
        setTitle(undefined);
        onClose();
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Add Show</DialogTitle>
            <DialogContent>
                <FormControl component="fieldset">
                    <TextField
                        sx={{ mt: 1, mb: 1 }}
                        label="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant='text'>Cancel</Button>
                <LoadingButton
                    onClick={handleSave}
                    disabled={!title}
                    variant='contained'
                    loading={loading}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}